// Content Thumbnail Override 타입 정의
export interface ContentThumbnailOverride {
  id: number;
  url: string;
  orientation: 'landscape' | 'portrait';
  language: string;
  width?: number;
  height?: number;
  is_override: boolean;
  created: string;
  modified: string;
}

export interface CreateThumbnailOverrideRequest {
  file?: File;
  external_url?: string;
  language: string;
  orientation?: 'landscape' | 'portrait';
  width?: number;
  height?: number;
}

export interface UpdateThumbnailOverrideRequest {
  file?: File;
  external_url?: string;
  orientation?: 'landscape' | 'portrait';
  width?: number;
  height?: number;
}

// 언어-서비스 매핑
export const THUMBNAIL_OVERRIDE_LANGUAGES = [
  { value: 'ko', label: 'Korean', flag: '🇰🇷', service: 'ODK' },
  { value: 'en', label: 'English', flag: '🇺🇸', service: 'Amasian' },
  { value: 'zh', label: 'Chinese', flag: '🇨🇳', service: 'ODC' },
  { value: 'vi', label: 'Vietnamese', flag: '🇻🇳', service: 'LG Channels' },
];

// Distribution Rule 표시용
export const THUMBNAIL_DISTRIBUTION_RULES = [
  { language: 'Korean (ko)', service: 'ODK' },
  { language: 'English (en)', service: 'AmasianTV' },
  { language: 'Chinese (zh)', service: 'ODC' },
  { language: 'Vietnamese (vi)', service: 'LG Channels' },
];
